export default __webpack_public_path__ + "static/media/nucleo.bd5cce8b.eot";